<template>
  <router-view />
</template>
<script>
  import Theme from '@/utils/theme'
  export default {
    mounted() {
     Theme.change('#d6476b')
    }
  }
</script>